import { useState } from 'react';
import { useEffect } from 'react';
import AnimatedLetters from '../AnimatedLetters/AnimatedLetters';
import './Experiences.scss';
import Loader from 'react-loaders';
import SEO from '../Hooks/SEO';
import ExperiencesUI from './ExperiencesUI';
import AnimateBG from '../AnimateBG';

const Experiences = () => {
  const [letterClass, setLetterClass] = useState('text-animate');

  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover');
    }, 3000);
  }, []);

  return (
    <>
      <AnimateBG>
        <div className="container experiences-page">
          <SEO
            description="Frontend Engineer at Devxhub, former Frontend Engineer at Nexuses, C-Sunshine, and Brillmark LLC. Experiences with more than 3 years in Frontend with Javascript, React, Nextjs."
            title="Nazmus - Experinences ✨"
            type="Experinences in Frontend with Javascript, React, NextJs Development"
            href="https://nazmus.me/experiences"
          />
          <div className="text-zone">
            <h1>
              <AnimatedLetters
                letterClass={letterClass}
                strArray={[
                  'P',
                  'r',
                  'o',
                  'f',
                  'e',
                  's',
                  's',
                  'i',
                  'o',
                  'n',
                  'a',
                  'l',
                  ' ',
                  'E',
                  'x',
                  'p',
                  'e',
                  'r',
                  'i',
                  'e',
                  'n',
                  'c',
                  'e',
                  's'
                ]}
                idx={8}
              />
            </h1>
            <ExperiencesUI />
          </div>
        </div>
        <Loader type="pacman" />
      </AnimateBG>
    </>
  );
};

export default Experiences;
